import { render, staticRenderFns } from "./rule_bak.vue?vue&type=template&id=4a00c426&"
import script from "./rule_bak.vue?vue&type=script&lang=js&"
export * from "./rule_bak.vue?vue&type=script&lang=js&"
import style0 from "./rule_bak.vue?vue&type=style&index=0&id=4a00c426&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports